export default __webpack_public_path__ + "static/media/fmono_logo_text_btm.f0834e5d.png";